export class Settings {
    private _parameters : any;
    constructor(primarySettingsObject : any){
        this._parameters = {};
        if(primarySettingsObject == undefined){
            primarySettingsObject = {
                _parameters : {}
            };
        }
        this.init(primarySettingsObject);
        
    }
    public init(primarySettingsObject: { _parameters: Object; }){
        this._parameters = primarySettingsObject._parameters;
    }
    public setParam(key: string,value: number | boolean){
        this._parameters[key]=value;
    }
    public setBayaPlus(enable : boolean){
        this.setParam("bayaPlus",enable);
    }
    public isBayaPlus(){
        return this.getParam("bayaPlus");
    }
    public getParam(key: string){
       return this._parameters[key];
    }
}